import localForage from "localforage";
import { pick } from "lodash";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const STORE_NAME = "colorPicker";
interface ColorPickerState {
  recentColors: string[];
}

const defaultState: ColorPickerState = {
  recentColors: [],
};

interface ColorPickerActions {
  addRecentColor: (color: string) => void;
}

type ColorPickerStore = ColorPickerState & ColorPickerActions;

const MAX_RECENT_COLORS = 8;

const persistedStateProps = ["recentColors"];

export const useColorPickerStore = create<ColorPickerStore>()(
  persist(
    (set) => ({
      ...defaultState,
      addRecentColor: (newColor: string) => {
        set((state) => {
          const newRecentColors = state.recentColors.filter(
            (color) => color !== newColor,
          );

          newRecentColors.unshift(newColor);

          if (newRecentColors.length > MAX_RECENT_COLORS) {
            newRecentColors.pop();
          }

          return { recentColors: newRecentColors };
        });
      },
    }),
    {
      version: 1,
      name: STORE_NAME,
      storage: createJSONStorage(() => localForage),
      partialize: (state) => pick(state, persistedStateProps),
    },
  ),
);
